
import { Link } from "react-router-dom";

import getIcon from "../../utils/getIcon";


const SiteOverviewStatistics = ({ dashboardData }) => {


  if (!dashboardData) return null;

  const urlMap = {
    students: "/master/student-list",
    chapters: "/master/chapter-list",
    semesters: "/master/semester-list",
    subjects: "/master/subject-list",
    topics:"/master/topic-list"
  };

  const stats = ["students", "chapters", "semesters", "subjects", "topics"].map(
    (key, index) => ({
      id: index + 1,
      title: key.charAt(0).toUpperCase() + key.slice(1),
      total_number: dashboardData[key] || 0,
      icon: key,
      url: urlMap[key] || "#",
    })
  );

  // Get upcoming deactivations
  const upcomingDeactivations = (dashboardData.upcoming_deactivations || []).slice(0,5);
const latestStudents =( dashboardData.latest_student || []).slice(0,5);
 
  const formatDate = (dateString) => {
    if (!dateString) return "-";
    const date = new Date(dateString);

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  };


  const getStatus = (status) => {
    const s = Number(status);

    switch (s) {
      case 0:
        return { text: "Pending", className: "text-warning fw-bold " };
      case 1:
        return { text: "Admin Approval Required", className: "text-warning fw-bold" };
      case 2:
        return { text: "Approved", className: "text-primary fw-bold" };
      case 3:
        return { text: "Rejected", className: "text-danger fw-bold" };
      case 4:
        return { text: "Expired", className: "text-black fw-bold" };
     default:
      return { text: "Unknown Status", className: "text-secondary fw-bold" };
    }
  };


  
  return (
    <>
      <div className="row g-3 fw-semibold ">
        {stats.map(({ id, title, total_number, icon, url }) => (
          <div key={id} className="col-12 col-sm-6 col-md-3">
            <Link to={url} className="text-decoration-none">
              <div className="card stretch stretch-full short-info-card h-100">
                <div className="card-body">
                  <div className="d-flex align-items-start justify-content-between mb-4">
                    <div className="d-flex gap-3 align-items-center">
                      <div className="icon-box">{getIcon(icon)}</div>
                      <div>
                        <div className="fs-4 fw-bold text-dark counter">
                          {total_number}
                        </div>
                        <h3 className="fs-13 fw-semibold">Total {title}</h3>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Link>
          </div>
        ))}
      </div>

     {/* Latest Students Table */}
      <div className="row mt-4">
        <div className="col-12">
          <div className="card">
            <div className="card-header bg-primary fw-bold text-white">
              Latest Students
             <Link to="/master/student-list" className="text-white">
    View More
  </Link>
            </div>
            <div className="table-responsive">
              <table className="table table-hover table-bordered table-striped table-sm mb-0">
                <thead>
                  <tr className="bg-primary">
                    <th className="text-white">S. No</th>
                    <th className="text-white">Student Name</th>
                    <th className="text-white">Phone</th>
                    <th className="text-white">Email</th>
                    <th className="text-white">Course</th>
                    <th className="text-white">Semester</th>
                   
                    <th className="text-white">Subscription Status</th>
                  </tr>
                </thead>
                <tbody>
                  {latestStudents.map((student, index) => (
                    <tr key={student.id} className="fw-semibold">
                      <td>{index + 1}</td>
                      <td>{student.name || "-"}</td>
                      <td>{student.phone || "-"}</td>
                      <td>{student.email || "-"}</td>
                      <td>{student.course_name || "-"}</td>
                      <td>{student.semester_name || "-"}</td>
                     
                      <td className={getStatus(student.subscription_status).className} >
{getStatus(student.subscription_status).text}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      {/* Upcoming Deactivations Table */}
      <div className="row mt-4">
        <div className="col-12">
          <div className="card">
            <div className="card-header d-flex justify-content-between align-items-center bg-primary text-white fw-bold">
             Subscription Ending
             <Link to="/master/student-renewal-list" className="text-white">
    View More
  </Link>
            </div>
            <div className="table-responsive">
              <table className="table table-hover table-bordered table-striped table-sm mb-0">
                <thead>
                  <tr className="bg-primary">
                    <th className="text-white">S. No</th>
                    <th className="text-white">Student Name</th>
                    <th className="text-white">Phone</th>
                    <th className="text-white">Email</th>
                    <th className="text-white">Package</th>
                    <th className="text-white">Subs. Start Date</th>
                    <th className="text-white">Subs. End Date</th>
                  
                  </tr>
                </thead>
                <tbody>
                  { upcomingDeactivations.map(
                    (item, index) => (
                      <tr key={index} className="fw-semibold">
                        <td>{ index + 1}</td>
                        <td>{item.name || "-"}</td>
                        <td>{item.phone || "-"}</td>
                        <td>{item.email || "-"}</td>
                        <td>{item.package_name || "-"}</td>
                        <td>{formatDate(item.activate_date)}</td>
                        <td>{formatDate(item.deactivate_date)}</td>
                        
                      </tr>
                    )
                  )}
                </tbody>
              </table>
            </div>

           
          </div>
        </div>
      </div>
    </>
  );
};

export default SiteOverviewStatistics;
